import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ModalStateRequestInvoice } from "../../../Orchestrator/Recoils/TicketAtom";

export interface IRequestInvoiceModalPopupAction {
    bookingId: string;
    isVisible: boolean;
    bookingRef: string;
}

export class RequestInvoicePopupOpenCloseAction extends BaseAction<boolean, IRequestInvoiceModalPopupAction> {

    override async run(): Promise<boolean> {
        try {
            const { bookingId, isVisible, bookingRef } = this.params!;
            updateRecoilState("modalStateRequestInvoiceAtom", {
                bookingId: bookingId,
                isVisible: isVisible,
                bookingRef: bookingRef
            });
        } catch (error) {
            console.error("Error in RequestInvoicePopupOpenCloseAction:", error);
        } finally {
            return true;
        }
    }
}

// Create a singleton instance
export const requestInvoicePopupOpenCloseAction = new RequestInvoicePopupOpenCloseAction();
